/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteProfiloDto } from '../../models/utente-profilo-dto';

export interface ApiAuthMeGet$Params {}

export function apiAuthMeGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAuthMeGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<UtenteProfiloDto>> {
    const rb = new RequestBuilder(rootUrl, apiAuthMeGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<UtenteProfiloDto>;
        }),
    );
}

apiAuthMeGet.PATH = '/api/auth/me';
